import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// @mui material components
import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";

// third party
import * as Yup from "yup";
import { Formik } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// Images & icon
import { ReactComponent as ShowIcon } from "assets/images/icons/show.svg";
import { ReactComponent as HiddenIcon } from "assets/images/icons/hidden.svg";

import { strengthColor, strengthIndicator } from "utils/password-strength";
import { Edit } from "@mui/icons-material";
import MDTypography from "components/MDTypography";
import { StrengthComponent } from "components/StrengthComponent";
import pxToRem from "assets/theme/functions/pxToRem";

const BasicInfoForm = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showReapetPass, setShowReapetPass] = useState(false);
  const [strength, setStrength] = useState(0);
  const [level, setLevel] = useState();
  const changePassword = (value) => {
    const temp = strengthIndicator(value);
    setStrength(temp);
    setLevel(strengthColor(temp));
  };
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleClickShowReapetPass = () => {
    setShowReapetPass(!showReapetPass);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const { t } = useTranslation();

  return (
 
      <Formik
        initialValues={{
          userName: "",
          password: "",
          reapetPass: "",
          submit: null,
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string().email("فرمت ایمیل معتبر نیست"),
          password: Yup.string().max(255).required("پسورد الزامی است"),
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
          } catch (err) {
            console.error(err);
          }
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
          <MDBox component="form" role="form">
            <MDInput
              formSx={{ mb: 3 }}
              fullWidth
              formError={touched.userName && errors.userName}
              label={t("labels.userName")}
              size="small"
              id="outlined-adornment-userName-login"
              type="userName"
              value={values.userName}
              name="userName"
              onBlur={handleBlur}
              onChange={handleChange}
              error={errors.userName}
            />

            <MDInput
              formError={touched.password && errors.password}
              formSx={{ mb: 3 }}
              fullWidth
              error={errors.password}
              size="small"
              id="outlined-adornment-password-login"
              type={showPassword ? "text" : "password"}
              value={values.password}
              name="password"
              onBlur={handleBlur}
              onChange={(e) => {
                handleChange(e);
                changePassword(e.target.value);
              }}
              label={t("labels.password")}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                    size="large"
                  >
                    {showPassword ? (
                      <ShowIcon style={{ width: pxToRem(24), height: pxToRem(24) }} />
                    ) : (
                      <HiddenIcon style={{ width: pxToRem(24), height: pxToRem(24) }} />
                    )}
                  </IconButton>
                </InputAdornment>
              }
            />
            <MDInput
              formError={touched.reapetPass && errors.reapetPass}
              formSx={{ mb: 2 }}
              fullWidth
              error={errors.reapetPass}
              size="small"
              id="outlined-adornment-reapetPass-login"
              type={showReapetPass ? "text" : "password"}
              value={values.reapetPass}
              name="reapetPass"
              onBlur={handleBlur}
              onChange={(e) => {
                handleChange(e);
              }}
              label={t("labels.reapetPass")}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowReapetPass}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                    size="large"
                  >
                    {showReapetPass ? (
                      <ShowIcon style={{ width: pxToRem(24), height: pxToRem(24) }} />
                    ) : (
                      <HiddenIcon style={{ width: pxToRem(24), height: pxToRem(24) }} />
                    )}
                  </IconButton>
                </InputAdornment>
              }
            />
            <StrengthComponent strength={strength} />
          </MDBox>
        )}
      </Formik>

  );
};
export default BasicInfoForm;
